import React, { Component } from 'react';

function Footer() {
  return (
    <div>
      <footer class="footer text-muted home_footer footer-style">
        © 2024 Accenture. All Rights Reserved.
      </footer>
    </div>
  );
}

export default Footer;
